
import {Component, Prop, Vue} from 'vue-property-decorator';
import LoyaltyStockAddForm from '@/form/loyalty/loyaltyStock/LoyaltyStockAddForm';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';

@Component({
  components: {FormGroup}
})
export default class LoyaltyStockAddComponent extends Vue {
  @Prop() readonly form!: LoyaltyStockAddForm;

}
